/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Contracts_Delete_ConfirmInputs */

const cs_contracts_delete_confirm = /** @type {(inputs: Contracts_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Smazat smlouvu „${i?.title}“?`)
};

const en_contracts_delete_confirm = /** @type {(inputs: Contracts_Delete_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete contract “${i?.title}”?`)
};

/**
* | output |
* | --- |
* | "Delete contract “{title}”?" |
*
* @param {Contracts_Delete_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_delete_confirm = /** @type {((inputs: Contracts_Delete_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Delete_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_delete_confirm(inputs)
	return cs_contracts_delete_confirm(inputs)
});